/*
 * @@Author: MuYang
 */
import {PROJECT_CODE} from '../../constants/index'

const auth = {
  pur_permlist: {
    url: '/purchaser/role/currentUserMoreObjPermissions',
    type: 'post',
    parameter: {
      code: String
    }
  },
  sur_permlist: {
    url: '/sur/apaas/permission/appResources',
    type: 'post',
    parameter: {
      code: String
    }
  }
}
export default auth[`${PROJECT_CODE}_permlist`]
